"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceKeywordForObjectParams = exports.replaceKeywordForArrayParams = void 0;
const escapeRegExp_1 = require("./escapeRegExp");
function isObject(obj) {
    return typeof obj === 'object' && !!obj;
}
function replaceKeyword(source, keyword, value, options = {}) {
    const { pattern, specElement, exactMatch, templateLiterals } = options;
    if (pattern instanceof RegExp) {
        return source.replace(pattern, value);
    }
    if (!pattern || !specElement) {
        return source.replace(new RegExp(`:${keyword}`, 'g'), value);
    }
    if (!exactMatch) {
        keyword = ` *${keyword} *`;
    }
    // TODO: change to pattern (?<!<templateLitterals>)<pattern> when all browsers support negative lookbehind
    const escapePattern = (0, escapeRegExp_1.escapeRegExp)(pattern).replace(specElement, keyword.toString());
    const replacementPattern = `(\\S|)${escapePattern}`;
    const escapeRegExpPatternWithBegin = new RegExp(`^${escapePattern}$`);
    return source.replace(new RegExp(replacementPattern, 'g'), (replacement) => {
        if (escapeRegExpPatternWithBegin.test(replacement)) {
            return value;
        }
        if (replacement[0] === templateLiterals) {
            return replacement.slice(1);
        }
        return `${replacement[0]}${value}`;
    });
}
function replaceKeywordForArrayParams(source, params, options) {
    for (const i in params) {
        source = replaceKeyword(source, i, params[i], options);
    }
    return source;
}
exports.replaceKeywordForArrayParams = replaceKeywordForArrayParams;
function replaceKeywordForNestedObjectParams(source, key, params, options) {
    Object.entries(params).forEach(([objectKey, objectValue]) => {
        const replaceKey = `${key}.${objectKey}`;
        if (isObject(objectValue)) {
            source = replaceKeywordForNestedObjectParams(source, replaceKey, objectValue, options);
        }
        else {
            source = replaceKeyword(source, replaceKey, objectValue, options);
        }
    });
    return source;
}
function replaceKeywordForObjectParams(source, params, options) {
    Object.entries(params).forEach(([key, value]) => {
        if (isObject(value)) {
            source = replaceKeywordForNestedObjectParams(source, key, value, options);
        }
        else {
            source = replaceKeyword(source, key, value, options);
        }
    });
    return source;
}
exports.replaceKeywordForObjectParams = replaceKeywordForObjectParams;
